import { render, staticRenderFns } from "./RemindPasswordContainer.vue?vue&type=template&id=136e469e&scoped=true&"
import script from "./RemindPasswordContainer.vue?vue&type=script&lang=ts&"
export * from "./RemindPasswordContainer.vue?vue&type=script&lang=ts&"
import style0 from "./RemindPasswordContainer.vue?vue&type=style&index=0&id=136e469e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136e469e",
  null
  
)

export default component.exports